import { Row } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  pupSelector,
  templatesMessageSelector,
} from "../../services/selector/index.";
import { resetState } from "../../services/slice/DealSlice";
import { setOpenPUDelete } from "../../services/slice/PopUpSlice";
import "../../assets/style/pageStyle/postDeals.scss";
import ModalDelete from "../../components/common/Modal/delete/ModalDelete";
import ModalGetLog from "../../components/common/Modal/getLog/ModalGetLog";
import TableTemplatesMessage from "../../components/common/Table/TableTemplatesMessage";
import ModalAddTemplatesMessage from "../../components/common/Modal/add/ModalAddTemplatesMessage";
import ModalEditTemplatesMessage from "../../components/common/Modal/edit/ModalEditTemplatesMessage";
import {
  deleteTemplatesMessage,
  resetStatus,
  setOpenModalGetLogTemplatesMessage,
} from "../../services/slice/TemplatesMessage";
import ModalDetailTemplatesMessage from "../../components/common/Modal/getDetail/ModalDetailTemplatesMessage";
import Notify from "../../components/common/Notify";

const TemplatesMessage = () => {
  const dispatch = useDispatch();
  const templatesMessageState = useSelector(templatesMessageSelector);
  const [dataGetLog, setDataGetLog] = useState("");
  const pupState = useSelector(pupSelector);
  const { dataDelete } = pupState;
  const { t } = useTranslation();

  useEffect(() => {
    return () => dispatch(resetState());
  }, [dispatch]);

  useEffect(() => {
    const data = templatesMessageState.dataLog.map((data) => ({
      userChange: data.modifiedBy,
      content: data.description,
      timeUpdate: data.modifiedAt,
    }));
    setDataGetLog(data);
  }, [templatesMessageState]);

  const handleDelete = () => {
    dispatch(deleteTemplatesMessage(dataDelete?.id));
    dispatch(setOpenPUDelete({ stateOpen: false, id: "", content: "" }));
  };

  return (
    <div className="wrapperPostDeals containerContentPage">
      {dataDelete.isOpenPUDelete && (
        <ModalDelete
          title="Xóa thông báo"
          setIsDelete={() => {}}
          handleDelete={handleDelete}
          width={600}
          content="Bạn có đồng ý xóa tin nhắn mẫu không?"
        />
      )}
      <Notify
        isNotify={templatesMessageState.isNotify}
        reset={resetStatus}
        title={"Bkav Pro"}
        content={templatesMessageState.msg}
        type={templatesMessageState.typeNotify}
      />
      {templatesMessageState.isOpenModalGetLog && (
        <ModalGetLog
          open={templatesMessageState.isOpenModalGetLog}
          setOpen={setOpenModalGetLogTemplatesMessage}
          data={dataGetLog}
        />
      )}

      {templatesMessageState.isOpenModalPostTemplatesMessage && (
        <ModalAddTemplatesMessage title={"Thêm mới Cấu hình"} />
      )}

      {templatesMessageState.isOpenModalEditTemplatesMessage && (
        <ModalEditTemplatesMessage title={"Chỉnh sửa Cấu hình"} />
      )}

      {templatesMessageState.isOpenModalDetail && (
        <ModalDetailTemplatesMessage title={"Xem chi tiết"} />
      )}

      <div className="headerPage">
        <h2 className="title">{t("Cấu hình tin nhắn mẫu của nhân viên")}</h2>
      </div>
      <Row className="tableContent">
        <TableTemplatesMessage />
      </Row>
    </div>
  );
};

export default TemplatesMessage;
